import { ALL_DRIVER_STATUS, DRIVER_VISIBLE_TIME, DRIVER_EVENTS} from "../constants";
import { getMinutesfromTimeString, getUTCDate, minutesToTime } from '@dataGrid/gridUtilities';
import { isBefore, isSameDay } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { getPendingStopStatus } from "../../utils/utils";
import appConstants from "../../../../../appConstants";
import { getDriverStatus } from "./DriverStatus";
import { RMAXLogger } from "../../../../../services/LoggerService/RMAXLogger";
import { EVENT_MODES } from "../../../../../signalR/constants";

export const isDriverReadyForDispatch = ({ driverClockedInTime, isCompanyDriver, terminalOffset}) => {
  return isCompanyDriver ? isDriverTimeBeforeCurrentDateAndTime(driverClockedInTime, terminalOffset) : true;
};

export const isDriverTimeBeforeCurrentDateAndTime = (dateTime, terminalOffset) => {
  const currentDateTime = utcToZonedTime(new Date(), terminalOffset);
  const dateTimeUTC = getUTCDate(dateTime);
  if (dateTime) {
    return isSameDay(dateTimeUTC, currentDateTime) && isBefore(dateTimeUTC, currentDateTime);
  }
  return false;
};


export const isWithinTime = (time, terminalOffset) => {
 return time &&  (timeDiffFromTerminal(time, terminalOffset ) <= DRIVER_VISIBLE_TIME);
};

// get time difference in minutes from call time to current terminal Time
export const timeDiffFromTerminal = (time, terminalOffset) => {
  const terminalCurrentTime = utcToZonedTime(new Date(), terminalOffset);
  const [timeHour, timeMinutes] = time.split(":").map(Number);
  const [currentHour, currentMinutes] = [
    terminalCurrentTime.getHours(),
    terminalCurrentTime.getMinutes(),
  ];
  const hourDiff = timeHour - currentHour;
  const minDiff = timeMinutes - currentMinutes;
  return hourDiff * 60 + minDiff;
}

export const getNotClockedInDriverStatus = (time, terminalOffset) => {
  if (!time) {
    return "";
  }
  const mins = timeDiffFromTerminal(time, terminalOffset);
  if (mins < 0) {
    return ALL_DRIVER_STATUS.LateBy
  } else {
    return ALL_DRIVER_STATUS.DueTime
  }
};

export const getNotClockedInDriverLabel = (time, terminalOffset) => {
  if (!time) {
    return "";
  }
  const mins = timeDiffFromTerminal(time, terminalOffset);
  if (mins < 0) {
    const absMins = Math.abs(mins);
    const [hours, minutes] = [
      Math.floor(absMins / 60)
        .toString()
        .padStart(2, "0"),
      Math.floor(absMins % 60)
        .toString()
        .padStart(2, "0"),
    ];
    const timeString = `${hours}:${minutes}`;
    return `Late by ${timeString} scheduled start ${time}`;
  } else {
    return `Due to start in ${mins} minutes`;
  }
};

export const getClockedInDriverStatusLabel = (driverClockedInTime, driverClockedInDept) => {
  const date = getUTCDate(new Date(driverClockedInTime));
  const clockedInStatus = `Clocked in at ${date.toTimeString().slice(0, 5)}`;
  return driverClockedInDept && driverClockedInDept.toUpperCase() === "DOCK" ? `${driverClockedInDept} - ${clockedInStatus}` : clockedInStatus ;
};

export const getActiveStop = (data) => {
  return data.stops.find((stop) => stop.stopId === data.currentStatus?.stopId);
};

export const renderTimeWithErrorIcon = (time, showError=false) => {
  return (
    
      <div className="dispatch-time">
        <div
          className={`dispatch-time-value ${
            showError ? "dispatch-time-value-error" : ""
          }`}
        >
          {time}
        </div>
        <div className="dispatch-time-icon-container">
          {showError ? (
            <ErrorOutlineIcon className="dispatch-time-icon"/>
          ) : (
            ""
          )}
        </div>
      </div>
  );
};

export const hasStopDelayed = (selectedStop) => {
  return (
    !selectedStop?.isStopCompleted &&
    getPendingStopStatus(selectedStop) === appConstants.STOP_STATUS.DELAYED
  );
}

export const getStopArrivalTime = (stopStatus, stopData) => {
  return stopStatus === DRIVER_EVENTS.ArrivedAtStop
    ? stopData?.actualArrivalTime
    : stopData?.plannedArrivalTime || stopData.arrivalTime;
};

export const getDeptTimeForArrivedStopInMinutes = ({actualArrivalTime,plannedArrivalTime,plannedDeptTime}) => {
  return (
    getMinutesfromTimeString(actualArrivalTime) +
    (getMinutesfromTimeString(plannedDeptTime) -
      getMinutesfromTimeString(plannedArrivalTime)) //when driver is arrived at a stop , departureTime = actualArrivalTime + plannedStopTime
  );
}

export const getStopArrivalTimeForDriverGrid = (driverStatus, stopData) => {
  return driverStatus === DRIVER_EVENTS.ArrivedAtStop
    ? minutesToTime({
        value: getDeptTimeForArrivedStopInMinutes({
          actualArrivalTime: stopData.actualArrivalTime,
          plannedArrivalTime: stopData.arrivalTime,
          plannedDeptTime: stopData.departureTime,
        }),
      })
    : stopData?.plannedArrivalTime || stopData.arrivalTime;
};

export const getZoneValue = (params) => {
  if (Number(params.data.dispatchZone) === 0) {
    return null;
  }
  return params.data.dispatchZone;
};

export const getArrivedAtOrEnrouteStop = (props) => {
  const { driverStatus } = getDriverStatus(props, false);
  if (
    [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      driverStatus
    )
  ) {
    return getActiveStop(props.data);
  }
  return null;
};


export const isPickupEditable = ({isEnabled ,isCompleted, isVoided}) => {
  return isEnabled && !(isCompleted || isVoided)
}


const getLatestBreak = (delays, delayType) => {
  const filteredDelay = delays.filter((delay) => delay.type === delayType);
  filteredDelay.sort((a, b) => {
    return new Date(`01/01/1970 ${b.startTime}`) - new Date(`01/01/1970 ${a.startTime}`);
  });
  return filteredDelay[0] || null;
};

export const getCustomLabel = (labelConfig, clientData) => {
  const { labelField, fallbackLabel } = labelConfig;
  const { clientCodes: { labels } = {} } = clientData || {};

  if (!labels || !labelField) {
    return fallbackLabel;
  }

  return labels[labelField] || fallbackLabel;
}

export const getLatestBreaks = (delays) => {
  return {
    latestLunchBreak: getLatestBreak(delays, appConstants.DELAY_STOP_TYPES.LUNCH_BREAK),
    latestFuelBreak: getLatestBreak(delays, appConstants.DELAY_STOP_TYPES.FUEL_BREAK),
    latestRestBreak: getLatestBreak(delays, appConstants.DELAY_STOP_TYPES.REST_BREAK)
  };
};

export const updateDriverListByEventMode = (currentDriverList, signalRData) => {
  // Skip if driverData is null and eventMode is not DELETE, We dont need to updated datas
  if (!signalRData.driverData && signalRData.eventMode !== EVENT_MODES.DELETE) {
    return { updatedDriverList: currentDriverList, isDriverListModified: false };
  }

  const driverIdToUpdate = signalRData.driverId?.toUpperCase();
  const existingDriverIndex = currentDriverList.findIndex(
    (driver) => driver.driverId?.toUpperCase() === driverIdToUpdate
  );
  let updatedDriverList = [...currentDriverList];

  switch (signalRData.eventMode) {
    case EVENT_MODES.DELETE: // Remove driver from the list
      if (existingDriverIndex !== -1) {
        updatedDriverList.splice(existingDriverIndex, 1);
        return { updatedDriverList, isDriverListModified: true };
      }
      break;
    case EVENT_MODES.ADD: // Add driver to the list if not already present
      if (existingDriverIndex === -1) {
        updatedDriverList.push({
          ...signalRData.driverData,
          driverId: signalRData.driverId
        });
        return { updatedDriverList, isDriverListModified: true };
      }
      break;
    case EVENT_MODES.UPDATE: // Update existing driver data
      if (existingDriverIndex !== -1) {
        updatedDriverList[existingDriverIndex] = {
          ...currentDriverList[existingDriverIndex],
          ...signalRData.driverData,
          driverId: signalRData.driverId
        };
        return { updatedDriverList, isDriverListModified: true };
      }
      break;
    default:
      RMAXLogger.warn(`Unknown eventMode: ${signalRData.eventMode}`);
      return { updatedDriverList: currentDriverList, isDriverListModified: false };
  }

  return { updatedDriverList: currentDriverList, isDriverListModified: false };
};